const Eyeopen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2056_26496)">
        <path
          d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z"
          fill="#7E7E7E"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2056_26496">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

const Eyeclose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M9.99999 13.0001C7.62968 13.0001 5.71093 11.1654 5.53437 8.84039L2.25624 6.30696C1.82531 6.84758 1.42874 7.41914 1.10874 8.04414C1.03726 8.18555 1.00001 8.34179 1.00001 8.50024C1.00001 8.65869 1.03726 8.81492 1.10874 8.95633C2.80343 12.2629 6.15843 14.5001 9.99999 14.5001C10.8409 14.5001 11.6522 14.3751 12.4341 14.1732L10.8125 12.9185C10.5447 12.9703 10.2727 12.9976 9.99999 13.0001ZM19.8069 14.8157L16.3522 12.1457C17.4016 11.2613 18.2647 10.177 18.8912 8.95602C18.9627 8.81461 19 8.65838 19 8.49993C19 8.34147 18.9627 8.18524 18.8912 8.04383C17.1966 4.73727 13.8416 2.50008 9.99999 2.50008C8.39109 2.50203 6.80831 2.90707 5.39624 3.67821L1.42062 0.605395C1.36878 0.565053 1.30949 0.535323 1.24615 0.517902C1.18282 0.500482 1.11667 0.495713 1.05149 0.503868C0.986304 0.512023 0.923369 0.532942 0.866275 0.56543C0.809182 0.597917 0.75905 0.641337 0.718743 0.693207L0.105306 1.48289C0.0239305 1.58758 -0.0125333 1.7203 0.0039342 1.85186C0.0204017 1.98342 0.088452 2.10306 0.193118 2.18446L18.5794 16.3948C18.6312 16.4351 18.6905 16.4648 18.7538 16.4823C18.8172 16.4997 18.8833 16.5045 18.9485 16.4963C19.0137 16.4881 19.0766 16.4672 19.1337 16.4347C19.1908 16.4022 19.2409 16.3588 19.2812 16.307L19.895 15.5173C19.9763 15.4125 20.0127 15.2798 19.9962 15.1482C19.9797 15.0167 19.9116 14.8971 19.8069 14.8157ZM14.0656 10.3782L12.8375 9.42883C12.9409 9.12992 12.9958 8.81636 13 8.50008C13.0061 8.03704 12.9035 7.57902 12.7005 7.16281C12.4975 6.74661 12.1996 6.38382 11.831 6.10359C11.4623 5.82336 11.0331 5.63349 10.5777 5.54925C10.1223 5.46501 9.65358 5.48873 9.20906 5.61852C9.3975 5.87386 9.49943 6.18273 9.49999 6.50008C9.49533 6.60569 9.47919 6.71047 9.45187 6.81258L7.15156 5.03477C7.95061 4.36702 8.95866 4.00085 9.99999 4.00008C10.591 3.99975 11.1763 4.11592 11.7225 4.34195C12.2686 4.56798 12.7648 4.89944 13.1827 5.31737C13.6006 5.7353 13.9321 6.2315 14.1581 6.77762C14.3841 7.32373 14.5003 7.90904 14.5 8.50008C14.5 9.17602 14.3347 9.80602 14.0656 10.3785V10.3782Z"
        fill="#828282"
      />
    </svg>
  );
};

const Dashboardsvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 15.6668C15.5 15.8878 15.4122 16.0998 15.2559 16.256C15.0996 16.4123 14.8877 16.5001 14.6667 16.5001H1.33333C1.11232 16.5001 0.900358 16.4123 0.744078 16.256C0.587797 16.0998 0.5 15.8878 0.5 15.6668V6.76178C0.49995 6.6359 0.528416 6.51165 0.583261 6.39835C0.638106 6.28506 0.717905 6.18565 0.816667 6.10761L7.48333 0.848444C7.63046 0.732186 7.81249 0.668945 8 0.668945C8.18751 0.668945 8.36954 0.732186 8.51667 0.848444L15.1833 6.10678C15.2822 6.18491 15.3621 6.28444 15.4169 6.39789C15.4718 6.51135 15.5002 6.63576 15.5 6.76178V15.6668ZM3.83333 9.00011C3.83333 10.1052 4.27232 11.165 5.05372 11.9464C5.83512 12.7278 6.89493 13.1668 8 13.1668C9.10507 13.1668 10.1649 12.7278 10.9463 11.9464C11.7277 11.165 12.1667 10.1052 12.1667 9.00011H10.5C10.5 9.66315 10.2366 10.299 9.76777 10.7679C9.29893 11.2367 8.66304 11.5001 8 11.5001C7.33696 11.5001 6.70107 11.2367 6.23223 10.7679C5.76339 10.299 5.5 9.66315 5.5 9.00011H3.83333Z"
        fill="#323232"
      />
    </svg>
  );
};
const Prayersvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="-9 0 163 163"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M2.80591 124.279L4.16922 126.165C8.63557 132.343 13.2548 138.733 17.9693 144.888C21.4151 149.385 25.0729 153.66 29.1527 158.383C31.5208 161.123 33.1314 161.504 36.0442 160.012C42.0063 157.041 47.4438 153.117 52.1428 148.395C53.6379 146.874 53.9804 145.259 53.2551 143.16C53.066 142.643 52.8502 142.136 52.6081 141.643C52.5274 141.47 52.4441 141.292 52.3594 141.106C53.1286 140.533 53.9031 139.974 54.6736 139.418C56.5494 138.065 58.4888 136.666 60.2425 135.123C62.9085 132.858 65.3548 130.347 67.5482 127.622C68.9002 125.759 70.0974 123.788 71.1279 121.73C71.5098 121.019 71.9023 120.286 72.3132 119.554C74.5093 126.468 78.9317 132.278 86.1711 137.784C87.3853 138.707 88.572 139.697 89.7153 140.654C90.1905 141.048 90.6624 141.442 91.133 141.831C91.1101 141.953 91.0923 142.066 91.0766 142.17C91.0628 142.358 91.0169 142.543 90.9407 142.715C89.3412 145.355 89.6937 147.755 92.0079 150.051C96.5025 154.496 101.581 158.309 107.104 161.385C107.927 161.872 108.862 162.14 109.818 162.161C110.545 162.137 111.258 161.96 111.911 161.642C112.564 161.324 113.143 160.872 113.609 160.314L114.493 159.372C116.098 157.665 117.758 155.899 119.27 154.055C127.157 144.436 134.099 135.884 140.491 127.912C141.657 126.37 142.657 124.711 143.476 122.961C144.377 121.16 143.976 119.645 142.285 118.458C140.567 117.254 138.883 115.934 137.253 114.657C136.528 114.088 135.801 113.52 135.07 112.96C134.317 112.381 133.571 111.797 132.824 111.211C131.122 109.877 129.363 108.497 127.558 107.238C124.342 104.993 122.942 105.097 120.069 107.799C119.665 108.179 119.243 108.531 118.711 108.98C118.514 109.147 118.298 109.325 118.068 109.52C117.952 109.364 117.841 109.214 117.732 109.067C117.39 108.605 117.067 108.166 116.714 107.765C110.545 100.651 105.825 92.3991 102.822 83.4742C96.4494 65.1399 92.2967 46.1081 90.4531 26.7856C89.8492 21.0847 88.7663 15.4448 87.216 9.9256C86.6837 7.9113 85.289 5.70075 83.0712 3.35697C80.8791 1.04141 77.875 0.958734 75.0324 3.13712C74.7344 3.36552 74.4456 3.60507 74.1634 3.84004L74.019 3.9595C71.8196 1.96292 69.7134 1.07162 67.7517 1.31184C65.8174 1.54878 64.0521 2.88309 62.5012 5.27807C60.8454 7.85439 59.6534 10.7009 58.9798 13.6884C57.7203 19.4399 56.6779 25.5845 55.8811 31.9497C54.2534 44.9524 50.7618 57.2968 47.0168 69.8486C42.9586 83.4578 38.3969 93.1289 32.2254 101.206C30.4179 103.573 28.4471 105.81 26.327 107.901L25.8412 107.38C25.4126 106.921 25.0603 106.537 24.7 106.164C21.9985 103.365 20.6056 103.198 17.2524 105.264C16.4228 105.775 15.622 106.352 14.8475 106.909L14.7354 106.989C13.4122 107.941 12.0918 108.896 10.7739 109.854C7.87816 111.955 4.88325 114.126 1.90216 116.207C0.40768 117.251 -0.0413887 118.546 0.567693 120.058C1.13767 121.552 1.88946 122.969 2.80591 124.279ZM70.5523 64.2992L70.5129 64.3242C70.4558 64.3603 70.3606 64.42 70.3514 64.4272C64.3193 63.574 60.5157 65.5699 58.0235 70.8955C57.0174 73.0516 56.2606 75.3159 55.7677 77.644C53.7285 87.3656 53.1567 96.0411 54.0198 104.165L54.0416 104.371C54.0838 105.345 54.2981 106.304 54.6748 107.203C54.9995 107.733 55.4459 108.177 55.977 108.499C56.1837 108.649 56.3905 108.799 56.5756 108.959L56.8381 109.186L57.0573 108.916C57.2476 108.693 57.45 108.48 57.6633 108.279C58.2187 107.855 58.6183 107.26 58.7994 106.585C58.9825 104.93 59.0153 103.238 59.0462 101.602C59.0633 100.683 59.081 99.7586 59.1244 98.8391C59.396 91.5741 60.4587 84.3596 62.2942 77.325C62.8843 75.3356 63.8194 73.4657 65.0567 71.8006C65.1905 71.5545 65.3781 71.3418 65.6054 71.179C65.8325 71.0156 66.0938 70.9053 66.3694 70.8568C66.9129 70.8666 67.411 71.4475 67.7339 71.9292C69.1234 74.0151 70.3389 76.1351 69.9556 79.1286C68.7611 88.4585 67.8888 97.8342 66.9536 108.249C66.0885 117.875 61.7324 125.169 53.6372 130.547C52.2471 131.47 50.9082 132.485 49.4912 133.559C48.8899 134.015 48.2709 134.483 47.6231 134.965L29.9789 112.177C30.8052 111.258 31.6316 110.365 32.4507 109.477C34.3915 107.373 36.2246 105.385 37.9639 103.248C45.7402 93.6895 49.9985 82.2173 53.4423 71.2447C58.4618 55.2833 62.1221 38.9259 64.3841 22.3475C64.8594 19.3997 65.5485 16.4904 66.4455 13.6424C66.6379 12.9756 66.8302 12.3101 67.0166 11.6445C67.2896 10.8317 67.6604 10.0551 68.1212 9.33227C68.2524 9.10846 68.3837 8.8794 68.515 8.63983C71.8498 18.1948 71.3484 51.842 70.5523 64.2992ZM6.75162 119.629L19.1422 110.805L46.3145 145.629L34.431 154.398L6.75162 119.629ZM77.071 78.6022L77.2994 75.0954C77.3066 74.9116 77.327 74.7285 77.3598 74.548L77.4418 74.1372C77.6702 72.9649 77.8862 71.8584 79.0905 71.5919C79.2343 71.5591 79.3813 71.5427 79.5283 71.542C80.4367 71.542 81.1692 72.2246 81.7133 73.5767C82.661 75.8253 83.3981 78.1572 83.9159 80.5417C85.4236 88.5799 86.0878 96.7533 85.8988 104.929C85.8988 105.148 85.8784 105.372 85.862 105.597C85.774 106.194 85.8101 106.802 85.967 107.385C86.2131 108.086 86.8485 109.323 87.6735 109.505C88.4716 109.682 89.5815 108.68 89.9812 108.07C90.4294 107.236 90.6867 106.311 90.7353 105.365C92.0138 95.6158 91.5157 85.7163 89.2638 76.1449C88.5431 73.408 87.3814 70.8069 85.8246 68.4434C84.2992 66.0609 81.7874 64.7147 77.9341 64.2225V63.343C77.9341 62.5212 77.9341 61.7192 77.9341 60.9145L77.8927 54.3511C77.8461 46.9962 77.7923 39.6415 77.7306 32.287C77.7083 29.9334 77.6118 28.0011 77.4261 26.2047C76.9109 20.9815 77.2712 15.7088 78.4926 10.6043C78.5878 10.245 78.704 9.89167 78.8405 9.54624C78.8772 9.44582 78.9166 9.33949 78.958 9.22594C79.0597 9.34474 79.1581 9.45697 79.2527 9.56396C79.571 9.8645 79.823 10.2271 79.995 10.6292C80.1919 11.3249 80.4006 12.02 80.6067 12.7157C81.4068 15.2113 82.0441 17.756 82.5153 20.3338C83.0758 23.8557 83.5392 27.4597 83.9881 30.9442C84.6963 36.4469 85.4281 42.136 86.561 47.6545C89.5854 62.3795 92.7909 76.7304 98.7249 90.3999C102.089 98.4394 107.003 105.739 113.184 111.882C113.554 112.257 113.905 112.652 114.234 113.063C114.369 113.226 114.51 113.396 114.661 113.573L96.41 135.725C87.0191 129.627 78.3095 122.109 77.7221 108.719C77.6053 106.051 77.365 103.347 77.1314 100.733C76.6916 95.7766 76.2374 90.6519 76.6063 85.5824C76.7711 83.255 76.9207 80.9257 77.071 78.5996V78.6022ZM97.5487 146.422C97.6564 146.261 97.7627 146.099 97.869 145.937C98.2175 145.384 98.5976 144.852 99.0065 144.342C106.342 135.568 113.687 126.802 121.15 117.897L125.498 112.708L137.356 121.692C129.805 131.41 122.06 140.313 113.866 149.734C112.163 151.691 110.457 153.656 108.747 155.631L97.8513 147.164L97.6833 146.776C97.638 146.683 97.5999 146.588 97.5711 146.489C97.556 146.466 97.5514 146.441 97.5461 146.419L97.5487 146.422Z"
          fill="#000000"
        />
        <path
          d="M37.0352 148.643C37.5578 148.639 38.074 148.528 38.552 148.316C39.0301 148.105 39.4599 147.799 39.8147 147.415C40.1695 147.031 40.4415 146.578 40.6146 146.086C40.7878 145.593 40.858 145.069 40.821 144.548C40.7908 143.505 40.3595 142.514 39.6167 141.781C38.8738 141.049 37.8768 140.631 36.8336 140.616H36.7884C36.3138 140.596 35.8401 140.674 35.3966 140.844C34.9531 141.014 34.5492 141.273 34.2095 141.605C33.8413 142.037 33.564 142.537 33.3942 143.078C33.2245 143.619 33.1659 144.189 33.2218 144.753C33.2 145.307 33.2901 145.86 33.4863 146.378C33.6824 146.897 33.9809 147.371 34.364 147.772C35.0411 148.373 35.926 148.686 36.8304 148.644C36.8974 148.647 36.9663 148.645 37.0352 148.643Z"
          fill="#000000"
        />
        <path
          d="M106.699 149.935H106.785C109.017 149.89 110.349 148.34 110.352 145.788C110.352 143.459 109.051 142.025 106.866 141.954C106.324 141.936 105.783 142.03 105.279 142.23C104.774 142.431 104.316 142.733 103.934 143.119C103.543 143.51 103.236 143.976 103.032 144.489C102.827 145.002 102.73 145.552 102.746 146.104C102.77 147.134 103.197 148.113 103.937 148.83C104.677 149.547 105.669 149.944 106.699 149.935Z"
          fill="#000000"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="144.394"
            height="161.459"
            fill="white"
            transform="translate(0.15564 0.853027)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const Keyboradsvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#323232"
        d="M11.3137,0 L16,4.68629 L16,11.3137 L11.3137,16 L4.68629,16 L0,11.3137 L0,4.68629 L4.68629,0 L11.3137,0 Z M10.4853,2 L5.51472,2 L2,5.51472 L2,10.4853 L5.51472,14 L10.4853,14 L14,10.4853 L14,5.51472 L10.4853,2 Z M8.04044,10 C8.59273,10 9.04047,10.4477 9.04047,11 C9.04047,11.5523 8.59275,12 8.04047,12 C7.48818,12 7.04047,11.5523 7.04047,11 C7.04047,10.4477 7.48817,10 8.04044,10 Z M8.04044,4 C8.76623,4 9.2686,4.72492 9.01376,5.40449 L8.04044,10 L7.06713,5.40449 C6.81229,4.72492 7.31466,4 8.04044,4 Z"
      />
    </svg>
  );
};

const Mediasvg = () => {
  return (
    <svg
      fill="#000000"
      width={20}
      height={20}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512.001 512.001"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M465.432,63.989c-2.471-2.027-5.719-2.838-8.855-2.21l-45.135,9.026c-0.027,0.005-0.054,0.011-0.082,0.017l-34.272,6.854
				l45.024-60.649c3.513-4.731,2.525-11.412-2.206-14.924c-4.73-3.511-11.41-2.525-14.924,2.206l-58.348,78.593H95.565
				c-29.169,0-52.9,23.731-52.9,52.899V243.34c0,29.168,23.731,52.899,52.9,52.899h11.101v53.334
				c0,5.892,4.777,10.667,10.667,10.667h53.332v141.094c0,5.892,4.777,10.667,10.667,10.667h42.667
				c5.892,0,10.667-4.776,10.667-10.667V360.24h53.332c5.891,0,10.667-4.776,10.667-10.667v-53.334h47.967l58.348,78.594
				c2.094,2.819,5.312,4.309,8.573,4.309c2.21,0,4.44-0.685,6.35-2.103c4.731-3.512,5.719-10.194,2.206-14.924l-45.025-60.649
				l79.491,15.897c0.694,0.139,1.396,0.207,2.092,0.207c2.444,0,4.84-0.842,6.763-2.418c2.471-2.026,3.904-5.053,3.904-8.249V72.238
				C469.337,69.042,467.903,66.015,465.432,63.989z M213.333,490.665h-21.332V360.24h21.332V490.665z M277.332,338.905H224h-42.667
				h-53.332v-42.667h149.33V338.905z M341.334,274.902H288H117.333H95.565c-17.405,0.001-31.565-14.159-31.565-31.563V135.801
				c0-17.404,14.159-31.564,31.565-31.564h245.768V274.902z M448.002,293.891l-85.333-17.065v-174.51l40.211-8.042v26.649
				c0,5.892,4.777,10.667,10.667,10.667c5.892,0,10.667-4.776,10.667-10.667V90.007l23.787-4.757V293.891z"
            />
            <path
              d="M148.232,157.57h79.324c5.892,0,10.667-4.776,10.667-10.667c0-5.892-4.776-10.667-10.667-10.667h-79.324
				c-5.891,0-10.667,4.776-10.667,10.667C137.564,152.794,142.341,157.57,148.232,157.57z"
            />
            <path
              d="M117.333,157.574h0.254c5.892,0,10.667-4.776,10.667-10.667c0-5.892-4.776-10.667-10.667-10.667h-0.254
				c-5.891,0-10.667,4.776-10.667,10.667C106.666,152.799,111.443,157.574,117.333,157.574z"
            />
            <path
              d="M117.333,200.236h110.222c5.892,0,10.667-4.776,10.667-10.667c0-5.892-4.776-10.667-10.667-10.667H117.333
				c-5.891,0-10.667,4.776-10.667,10.667C106.666,195.46,111.443,200.236,117.333,200.236z"
            />
            <path
              d="M117.333,242.901h110.224c5.892,0,10.667-4.776,10.667-10.667c0-5.892-4.776-10.667-10.667-10.667H117.333
				c-5.891,0-10.667,4.776-10.667,10.667C106.666,238.125,111.443,242.901,117.333,242.901z"
            />
            <path
              d="M413.551,140.897c-5.891,0-10.667,4.776-10.667,10.667v0.256c0,5.892,4.777,10.667,10.667,10.667
				c5.892,0,10.667-4.776,10.667-10.667v-0.256C424.219,145.674,419.443,140.897,413.551,140.897z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const Userssvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        fill="#323232"
      />
      <path
        d="M15.6309 7.15517C15.9015 7.05482 16.1943 7 16.4999 7C17.8806 7 18.9999 8.11929 18.9999 9.5C18.9999 10.8807 17.8806 12 16.4999 12C16.1943 12 15.9015 11.9452 15.6309 11.8448"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M3 19C3.69137 16.6928 5.46998 16 9.5 16C13.53 16 15.3086 16.6928 16 19"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M17 15C19.403 15.095 20.5292 15.6383 21 17"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        stroke="#323232"
        strokeWidth={2}
      />
    </svg>
  );
};

const Contactsvg = () => {
  return (
    <svg
      fill="#323232"
      version="1.1"
      id="XMLID_276_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      width={20}
      height={20}
    >
      <g id="contact-us">
        <g>
          <path d="M4,24v-5H0V0h23v19h-9.3L4,24z M2,17h4v3.7l7.3-3.7H21V2H2V17z" />
        </g>
        <g>
          <rect x={5} y={8} width={3} height={3} />
        </g>
        <g>
          <rect x={10} y={8} width={3} height={3} />
        </g>
        <g>
          <rect x={15} y={8} width={3} height={3} />
        </g>
      </g>
    </svg>
  );
};

const Categoryssvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.5H16V5.5C16 4.70435 15.6839 3.94129 15.1213 3.37868C14.5587 2.81607 13.7956 2.5 13 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V6.5H5C4.20435 6.5 3.44129 6.81607 2.87868 7.37868C2.31607 7.94129 2 8.70435 2 9.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.1839 21.1213 20.6213C21.6839 20.0587 22 19.2956 22 18.5V9.5C22 8.70435 21.6839 7.94129 21.1213 7.37868C20.5587 6.81607 19.7956 6.5 19 6.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H13C13.2652 4.5 13.5196 4.60536 13.7071 4.79289C13.8946 4.98043 14 5.23478 14 5.5V6.5H10V5.5ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3946 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V13C4.97544 13.3869 5.97818 13.7011 7 13.94V14.53C7 14.7952 7.10536 15.0496 7.29289 15.2371C7.48043 15.4246 7.73478 15.53 8 15.53C8.26522 15.53 8.51957 15.4246 8.70711 15.2371C8.89464 15.0496 9 14.7952 9 14.53V14.32C9.99435 14.4554 10.9965 14.5255 12 14.53C13.0035 14.5255 14.0057 14.4554 15 14.32V14.53C15 14.7952 15.1054 15.0496 15.2929 15.2371C15.4804 15.4246 15.7348 15.53 16 15.53C16.2652 15.53 16.5196 15.4246 16.7071 15.2371C16.8946 15.0496 17 14.7952 17 14.53V13.94C18.0218 13.7011 19.0246 13.3869 20 13V18.5ZM20 10.81C19.0274 11.2205 18.0244 11.5548 17 11.81V11.5C17 11.2348 16.8946 10.9804 16.7071 10.7929C16.5196 10.6054 16.2652 10.5 16 10.5C15.7348 10.5 15.4804 10.6054 15.2929 10.7929C15.1054 10.9804 15 11.2348 15 11.5V12.24C13.0113 12.54 10.9887 12.54 9 12.24V11.5C9 11.2348 8.89464 10.9804 8.70711 10.7929C8.51957 10.6054 8.26522 10.5 8 10.5C7.73478 10.5 7.48043 10.6054 7.29289 10.7929C7.10536 10.9804 7 11.2348 7 11.5V11.83C5.97562 11.5748 4.9726 11.2405 4 10.83V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V10.81Z"
        fill="#323232"
      />
    </svg>
  );
};

const Reportsvg = () => {
  return (
    <svg
      version="1.1"
      id="Uploaded to svgrepo.com"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: "\n\t.feather_een{fill:#0B1719;}\n",
        }}
      />
      <path
        className="feather_een"
        d="M8,10.5L8,10.5C8,10.224,8.224,10,8.5,10h3c0.276,0,0.5,0.224,0.5,0.5v0c0,0.276-0.224,0.5-0.5,0.5h-3
	C8.224,11,8,10.776,8,10.5z M8.5,13h3c0.276,0,0.5-0.224,0.5-0.5v0c0-0.276-0.224-0.5-0.5-0.5h-3C8.224,12,8,12.224,8,12.5v0
	C8,12.776,8.224,13,8.5,13z M30,8v18c0,1.657-1.343,3-3,3H5c-1.657,0-3-1.343-3-3V8c0-1.657,1.343-3,3-3c0,0,0.448-1,1-1h3.092
	C9.299,3.419,9.849,3,10.5,3s1.201,0.419,1.408,1H14c0.552,0,1,0.448,1,1h12C28.657,5,30,6.343,30,8z M6,15h8V5h-2v2.5
	c0,0.892-0.783,1.605-1.697,1.487C9.547,8.89,9,8.21,9,7.448V7.25c0-0.276,0.224-0.5,0.5-0.5h0c0.276,0,0.5,0.224,0.5,0.5V7.5
	c0,0.303,0.271,0.544,0.584,0.493C10.83,7.953,11,7.721,11,7.472L11,5H6V15z M28.976,26.242C28.447,26.708,27.76,27,27,27H5
	c-0.76,0-1.447-0.292-1.976-0.758C3.145,27.231,3.978,28,5,28h22C28.022,28,28.855,27.231,28.976,26.242z M29,8c0-1.105-0.895-2-2-2
	H15v9c0,0.552-0.448,1-1,1H6c-0.552,0-1-0.448-1-1l0-9C3.895,6,3,6.895,3,8v16c0,1.105,0.895,2,2,2h22c1.105,0,2-0.895,2-2V8z
	 M26.691,14.038C26.63,14.013,26.565,14,26.5,14h-4c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h2.793l-3,3h-1.586l-1.854-1.854
	c-0.195-0.195-0.512-0.195-0.707,0L15.293,19H11.5c-0.133,0-0.26,0.053-0.354,0.146L8.293,22H5.5C5.224,22,5,22.224,5,22.5
	S5.224,23,5.5,23h3c0.133,0,0.26-0.053,0.354-0.146L11.707,20H15.5c0.133,0,0.26-0.053,0.354-0.146l2.646-2.646l1.646,1.646
	C20.24,18.947,20.367,19,20.5,19h2c0.133,0,0.26-0.053,0.354-0.146L26,15.707V18.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-4
	c0-0.065-0.013-0.13-0.038-0.191C26.911,14.187,26.813,14.089,26.691,14.038z"
      />
    </svg>
  );
};

const Adminsvg = () => {
  return (
    <svg
   width={24}
  height={24}
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 496 496"
  xmlSpace="preserve"
>
  <g>
    <g>
      <g>
        <path
          d="M448,351.08V208c0-57.344-46.656-104-104-104c-8.272,0-16.28,1.072-24,2.904V24h-80h-8h-30.472
				C193.016,9.264,177.24,0,160,0s-33.016,9.264-41.528,24H88h-8H0v416h192v56h304v-77.088C496,387.936,476.616,361.128,448,351.08z
				 M344,120c48.52,0,88,39.48,88,88v138.864l-40-9.232v-20.12c14.688-13.192,24-32.264,24-53.512l-0.048-59.944l-11.056,4.568
				C404.72,208.704,386.552,216,344,216s-60.72-7.296-60.848-7.352L272,203.872V264c0,21.256,9.312,40.328,24,53.512v20.12
				l-40,9.232V248v-40C256,159.48,295.48,120,344,120z M325.696,434.384l-45.008-45.016l6.656-33.312l11.368-2.624L325.696,434.384z
				 M288,264v-37.328c10.456,2.44,28.616,5.328,56,5.328c27.384,0,45.544-2.888,56-5.328V264c0,30.872-25.128,56-56,56
				S288,294.872,288,264z M312,342.704V328.4c9.656,4.824,20.496,7.6,32,7.6c11.504,0,22.344-2.776,32-7.6v14.304l-32,96
				L312,342.704z M389.288,353.432l11.368,2.624l6.656,33.312l-45.008,45.016L389.288,353.432z M240,40h64v72.024
				c-5.608,2.344-10.936,5.232-16,8.48V56h-48V40z M96,40h32.608l2.096-4.792C135.816,23.536,147.312,16,160,16
				s24.184,7.536,29.296,19.208L191.392,40H224v32H96V40z M192,418.912V424H16V40h64v16H32v352h160.864
				C192.328,411.568,192,415.208,192,418.912z M48,392V72h32v16h160V72h32v61.128c-6.112,5.88-11.464,12.496-16,19.704V104H64v144
				h176v17.472c-2.512-0.896-5.184-1.472-8-1.472c-13.232,0-24,10.768-24,24c0,4.52,1.328,8.704,3.512,12.312l-19.448,29.176
				C189.528,328.584,186.84,328,184,328c-2.84,0-5.528,0.584-8.056,1.488l-19.448-29.176C158.672,296.704,160,292.52,160,288
				c0-13.232-10.768-24-24-24s-24,10.768-24,24c0,6.024,2.312,11.48,5.992,15.696l-20.896,26.12C94.288,328.656,91.224,328,88,328
				c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24c0-4.152-1.152-8-3.016-11.416l23.176-28.976
				c1.256,0.208,2.528,0.392,3.84,0.392c2.84,0,5.528-0.584,8.056-1.496l19.448,29.176c-2.176,3.616-3.504,7.8-3.504,12.32
				c0,13.232,10.768,24,24,24s24-10.768,24-24c0-4.52-1.328-8.704-3.512-12.312l19.448-29.176C226.472,311.416,229.16,312,232,312
				c2.816,0,5.488-0.576,8-1.472v40.552c-19.848,6.968-35.216,22.008-42.784,40.92H48z M240,120v88v24H80V120H240z M240,288
				c0,4.416-3.584,8-8,8s-8-3.584-8-8c0-4.416,3.584-8,8-8S240,283.584,240,288z M192,352c0,4.416-3.584,8-8,8s-8-3.584-8-8
				c0-4.416,3.584-8,8-8S192,347.584,192,352z M144,288c0,4.416-3.584,8-8,8s-8-3.584-8-8c0-4.416,3.584-8,8-8S144,283.584,144,288z
				 M96,352c0,4.416-3.584,8-8,8s-8-3.584-8-8c0-4.416,3.584-8,8-8S96,347.584,96,352z M480,480h-32v-32h-16v32H256v-32h-16v32h-32
				v-61.088c0-26.232,17.848-48.672,43.408-54.56l18.832-4.344l-6.928,34.624L344,475.312l80.688-80.68l-6.928-34.624l18.832,4.344
				C462.152,370.24,480,392.68,480,418.912V480z"
        />
        <path d="M160,130.664L96,216h128L160,130.664z M160,157.336L192,200h-64L160,157.336z" />
      </g>
    </g>
  </g>
</svg>

  );
};

const ManageBiblePrayerSvg = () => {
  return (
     <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 3C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20V19H4V5H20V3H4Z" />
      <path d="M12 7V10H9V12H12V15H14V12H17V10H14V7H12Z" />
    </svg>
  );
};


export {
  Eyeopen,
  Eyeclose,
  Dashboardsvg,
  Prayersvg,
  Userssvg,
  Categoryssvg,
  Mediasvg,
  Keyboradsvg,
  Contactsvg,
  Reportsvg,
  Adminsvg,
  ManageBiblePrayerSvg
};
